(function () {
	"use strict";

	angular.module("eSign")
		.controller("AmlController",
			[
				'$scope', 'signTaskService', 'appConfig', '$window', 'sessionService',
				function ($scope, signTaskService, appConfig, $window, sessionManager) {
					$scope.loading = false;
					$scope.customerInfo = {
						irregularIncomeAboveLimitList: []
					};

					$scope.illogicalCitizenship;
					$scope.isRelegitimizing = true;

					var parseRadioValue = function (value) {
						if (value == "yes") {
							return true;
						} else if (value == "no") {
							return false;
						}
						return -1;
					}

					var determineLogicalCitizenship = function (firstRadio, secondRadio) {
						if (firstRadio && secondRadio && firstRadio.length && secondRadio.length) {
							return !(parseRadioValue(firstRadio) || parseRadioValue(secondRadio));
						} else {
							return false;
						}

					}

					$scope.$watch('customerInfo.isCitizen',
						function () {
							$scope.illogicalCitizenship = determineLogicalCitizenship($scope.customerInfo.isCitizen,
								$scope.customerInfo.hasOtherCitizenship);
						});
					$scope.$watch('customerInfo.hasOtherCitizenship',
						function () {
							$scope.illogicalCitizenship = determineLogicalCitizenship($scope.customerInfo.isCitizen,
								$scope.customerInfo.hasOtherCitizenship);
						});
					$scope.$watch('customerInfo.irregularIncomeAboveLimit',
						function () {
							var irregularIncome = $scope.customerInfo.irregularIncomeAboveLimit;
							if (irregularIncome === 'yes') {
								$scope.addSourceOfFunds();
							} else if (irregularIncome === 'no') {
								$scope.customerInfo.irregularIncomeAboveLimitList = [];
							}
						});

					// When checking "unknown ssn", remove any text from ssn field
					$scope.$watch('customerInfo.pepCloseRelationSsnUnknown',
						function () {
							if ($scope.customerInfo.pepCloseRelationSsnUnknown) {
								$scope.customerInfo.pepCloseRelationSsn = "";
							}
						});
					
					var parseRadioButtonValues = function () {

						if ($scope.customerInfo != null) {

							// Uncritically load all data from customerInfo object
							$scope.customerInfoParsed = JSON.parse(JSON.stringify($scope.customerInfo));

							// Assign values that must be interpreted
							$scope.customerInfoParsed.willRecieveMoneyTransfersFromAbroadAboveLimit = parseRadioValue($scope.customerInfoParsed.willRecieveMoneyTransfersFromAbroadAboveLimit);
							$scope.customerInfoParsed.willTransferMoneyAbroadAboveLimit = parseRadioValue($scope.customerInfoParsed.willTransferMoneyAbroadAboveLimit);
							$scope.customerInfoParsed.willDepositCashAboveLimit = parseRadioValue($scope.customerInfoParsed.willDepositCashAboveLimit);
							$scope.customerInfoParsed.isStandardBankCustomer = parseRadioValue($scope.customerInfoParsed.isStandardBankCustomer);
							$scope.customerInfoParsed.isPoliticallyExposedPerson = parseRadioValue($scope.customerInfoParsed.isPoliticallyExposedPerson);
							$scope.customerInfoParsed.hasCloseRelationToPoliticallyExposedPerson = parseRadioValue($scope.customerInfoParsed.hasCloseRelationToPoliticallyExposedPerson);
							$scope.customerInfoParsed.isCitizen = parseRadioValue($scope.customerInfoParsed.isCitizen);
							$scope.customerInfoParsed.isTaxableAbroad = parseRadioValue($scope.customerInfoParsed.isTaxableAbroad);
							$scope.customerInfoParsed.irregularIncomeAboveLimit = parseRadioValue($scope.customerInfoParsed.irregularIncomeAboveLimit);
							$scope.customerInfoParsed.digitalCurrencyTradingAboveLimit = parseRadioValue($scope.customerInfoParsed.digitalCurrencyTradingAboveLimit);
							$scope.customerInfoParsed.taxResidentOfUsaOrResidentOfUsa = parseRadioValue($scope.customerInfoParsed.taxResidentOfUsaOrResidentOfUsa);
							$scope.customerInfoParsed.willUseBnBankAsPrimaryBank = parseRadioValue($scope.customerInfoParsed.willUseBnBankAsPrimaryBank);

							delete $scope.customerInfoParsed.hasOtherCitizenship;
						}
					}
					
					$scope.submitForm = function () {

						parseRadioButtonValues();
						$scope.loading = true;

						signTaskService.submitAmlForm($scope.customerInfoParsed).then(function (response) {

							// TODO: Possible response handling
							$scope.formCompleted = true;
							$scope.loading = false;
							if (!$scope.isRelegitimizing) {
								$scope.continue();
							}
						});
					};

					$scope.addSourceOfFunds = function () {
						$scope.customerInfo.irregularIncomeAboveLimitList.push({ type: "", amount: null, incomeTypeComment: "" });
					};

					$scope.removeSourceOfFunds = function (index) {
						var parsedIndex = parseInt(index);
						if (isNaN(parsedIndex) || parsedIndex < 0) {
							return;
						}
						$scope.customerInfo.irregularIncomeAboveLimitList.splice(parsedIndex, 1);
					};

					$scope.continue = function () {
						$window.location = appConfig.chooseSignTaskUrl;
					};

					$scope.sourceOfFundsChoices = [
						{
							display: 'Arv/gave',
							value: 'INHERITANCE_OR_GIFT'
						},
						{
							display: 'Næringsvirksomhet',
							value: 'BUSINESS'
						},
						{
							display: 'Oppsparte midler',
							value: 'SAVED_FUNDS'
						},
						{
							display: 'Leieinntekter',
							value: 'RENTAL_INCOME'
						},
						{
							display: 'Annet',
							value: 'OTHER'
						}
					];

					$scope.relations = [
						{
							display: 'Agent/Representant',
							value: 'AGENT_OR_REPRESENTATIVE'
						},
						{
							display: 'Barn',
							value: 'CHILD'
						},
						{
							display: 'Ektefelle',
							value: 'SPOUSE'
						},
						{
							display: 'Forelder',
							value: 'PARENT'
						},
						{
							display: 'Søsken',
							value: 'SIBLING'
						}
					];

					$scope.positions = [
						{
							display: 'Embetsmann/kvinne i departement',
							value: 'STATE_OFFICIAL'
						},
						{
							display: 'Fagforening',
							value: 'UNION'
						},
						{
							display: 'Folkevalgt',
							value: 'ELECTED_OFFICIAL'
						},
						{
							display: 'Statsoverhode',
							value: 'HEAD_OF_STATE'
						},
						{
							display: 'Styremedlem',
							value: 'BOARD_MEMBER'
						}
					];

					// Norwegian ISO 3166-1 Alpha-3, e.g. "NOR" -> Norge, "FIN" -> Finland
					$scope.landcodes = [
						{ "code": "AFG", "name": "Afghanistan" },
						{ "code": "ALB", "name": "Albania" },
						{
							"code": "DZA",
							"name": "Algerie"
						},
						{
							"code": "ASM",
							"name": "Amerikansk Samoa"
						},
						{
							"code": "AND",
							"name": "Andorra"
						},
						{
							"code": "AGO",
							"name": "Angola"
						},
						{
							"code": "AIA",
							"name": "Anguilla"
						},
						{
							"code": "ATA",
							"name": "Antarktis"
						},
						{
							"code": "ATG",
							"name": "Antigua og Barbuda"
						},
						{
							"code": "ARG",
							"name": "Argentina"
						},
						{
							"code": "ARM",
							"name": "Armenia"
						},
						{
							"code": "ABW",
							"name": "Aruba"
						},
						{
							"code": "AZE",
							"name": "Aserbajdsjan"
						},
						{
							"code": "AUS",
							"name": "Australia"
						},
						{
							"code": "BHS",
							"name": "Bahamas"
						},
						{
							"code": "BHR",
							"name": "Bahrain"
						},
						{
							"code": "BGD",
							"name": "Bangladesh"
						},
						{
							"code": "BRB",
							"name": "Barbados"
						},
						{
							"code": "BEL",
							"name": "Belgia"
						},
						{
							"code": "BLZ",
							"name": "Belize"
						},
						{
							"code": "BEN",
							"name": "Benin"
						},
						{
							"code": "BMU",
							"name": "Bermuda"
						},
						{
							"code": "BTN",
							"name": "Bhutan"
						},
						{
							"code": "BOL",
							"name": "Bolivia"
						},
						{
							"code": "BES",
							"name": "Bonaire, Sint Eustatius og Saba"
						},
						{
							"code": "BIH",
							"name": "Bosnia-Hercegovina"
						},
						{
							"code": "BWA",
							"name": "Botswana"
						},
						{
							"code": "BVT",
							"name": "Bouvetøya"
						},
						{
							"code": "BRA",
							"name": "Brasil"
						},
						{
							"code": "BRN",
							"name": "Brunei"
						},
						{
							"code": "BGR",
							"name": "Bulgaria"
						},
						{
							"code": "BFA",
							"name": "Burkina Faso"
						},
						{
							"code": "BDI",
							"name": "Burundi"
						},
						{
							"code": "CAN",
							"name": "Canada"
						},
						{
							"code": "CYM",
							"name": "Caymanøyene"
						},
						{
							"code": "CHL",
							"name": "Chile"
						},
						{
							"code": "CXR",
							"name": "Christmasøya"
						},
						{
							"code": "COL",
							"name": "Colombia"
						},
						{
							"code": "COK",
							"name": "Cookøyene"
						},
						{
							"code": "CRI",
							"name": "Costa Rica"
						},
						{
							"code": "CUB",
							"name": "Cuba"
						},
						{
							"code": "CUW",
							"name": "Curaçao"
						},
						{
							"code": "DNK",
							"name": "Danmark"
						},
						{
							"code": "VIR",
							"name": "De amerikanske Jomfruøyer"
						},
						{
							"code": "VGB",
							"name": "De britiske Jomfruøyer"
						},
						{
							"code": "ARE",
							"name": "De forente arabiske emirater"
						},
						{
							"code": "ATF",
							"name": "De franske sørterritorier"
						},
						{
							"code": "PSE",
							"name": "De palestinske territoriene"
						},
						{
							"code": "COD",
							"name": "Den demokratiske republikken Kongo"
						},
						{
							"code": "DOM",
							"name": "Den dominikanske republikk"
						},
						{
							"code": "CAF",
							"name": "Den sentralafrikanske republikk"
						},
						{
							"code": "IOT",
							"name": "Det britiske territoriet i Indiahavet"
						},
						{
							"code": "DJI",
							"name": "Djibouti"
						},
						{
							"code": "DMA",
							"name": "Dominica"
						},
						{
							"code": "ECU",
							"name": "Ecuador"
						},
						{
							"code": "EGY",
							"name": "Egypt"
						},
						{
							"code": "GNQ",
							"name": "Ekvatorial-Guinea"
						},
						{
							"code": "SLV",
							"name": "El Salvador"
						},
						{
							"code": "CIV",
							"name": "Elfenbenskysten"
						},
						{
							"code": "ERI",
							"name": "Eritrea"
						},
						{
							"code": "EST",
							"name": "Estland"
						},
						{
							"code": "ETH",
							"name": "Etiopia"
						},
						{
							"code": "FLK",
							"name": "Falklandsøyene"
						},
						{
							"code": "FJI",
							"name": "Fiji"
						},
						{
							"code": "PHL",
							"name": "Filippinene"
						},
						{
							"code": "FIN",
							"name": "Finland"
						},
						{
							"code": "FRA",
							"name": "Frankrike"
						},
						{
							"code": "GUF",
							"name": "Fransk Guyana"
						},
						{
							"code": "PYF",
							"name": "Fransk Polynesia"
						},
						{
							"code": "FRO",
							"name": "Færøyene"
						},
						{
							"code": "GAB",
							"name": "Gabon"
						},
						{
							"code": "GMB",
							"name": "Gambia"
						},
						{
							"code": "GEO",
							"name": "Georgia"
						},
						{
							"code": "GHA",
							"name": "Ghana"
						},
						{
							"code": "GIB",
							"name": "Gibraltar"
						},
						{
							"code": "GRD",
							"name": "Grenada"
						},
						{
							"code": "GRL",
							"name": "Grønland"
						},
						{
							"code": "GLP",
							"name": "Guadeloupe"
						},
						{
							"code": "GUM",
							"name": "Guam"
						},
						{
							"code": "GTM",
							"name": "Guatemala"
						},
						{
							"code": "GIN",
							"name": "Guinea"
						},
						{
							"code": "GNB",
							"name": "Guinea-Bissau"
						},
						{
							"code": "GUY",
							"name": "Guyana"
						},
						{
							"code": "HTI",
							"name": "Haiti"
						},
						{
							"code": "HMD",
							"name": "Heard- og McDonaldøyene"
						},
						{
							"code": "GRC",
							"name": "Hellas"
						},
						{
							"code": "HND",
							"name": "Honduras"
						},
						{
							"code": "HKG",
							"name": "Hongkong"
						},
						{
							"code": "BLR",
							"name": "Hviterussland"
						},
						{
							"code": "IND",
							"name": "India"
						},
						{
							"code": "IDN",
							"name": "Indonesia"
						},
						{
							"code": "IRQ",
							"name": "Irak"
						},
						{
							"code": "IRN",
							"name": "Iran"
						},
						{
							"code": "IRL",
							"name": "Irland"
						},
						{
							"code": "ISL",
							"name": "Island"
						},
						{
							"code": "ISR",
							"name": "Israel"
						},
						{
							"code": "ITA",
							"name": "Italia"
						},
						{
							"code": "JAM",
							"name": "Jamaica"
						},
						{
							"code": "JPN",
							"name": "Japan"
						},
						{
							"code": "YEM",
							"name": "Jemen"
						},
						{
							"code": "JEY",
							"name": "Jersey"
						},
						{
							"code": "JOR",
							"name": "Jordan"
						},
						{
							"code": "KHM",
							"name": "Kambodsja"
						},
						{
							"code": "CMR",
							"name": "Kamerun"
						},
						{
							"code": "CPV",
							"name": "Kapp Verde"
						},
						{
							"code": "KAZ",
							"name": "Kasakhstan"
						},
						{
							"code": "KEN",
							"name": "Kenya"
						},
						{
							"code": "CHN",
							"name": "Kina"
						},
						{
							"code": "KGZ",
							"name": "Kirgisistan"
						},
						{
							"code": "KIR",
							"name": "Kiribati"
						},
						{
							"code": "CCK",
							"name": "Kokosøyene"
						},
						{
							"code": "COM",
							"name": "Komorene"
						},
						{
							"code": "HRV",
							"name": "Kroatia"
						},
						{
							"code": "KWT",
							"name": "Kuwait"
						},
						{
							"code": "CYP",
							"name": "Kypros"
						},
						{
							"code": "LAO",
							"name": "Laos"
						},
						{
							"code": "LVA",
							"name": "Latvia"
						},
						{
							"code": "LSO",
							"name": "Lesotho"
						},
						{
							"code": "LBN",
							"name": "Libanon"
						},
						{
							"code": "LBR",
							"name": "Liberia"
						},
						{
							"code": "LBY",
							"name": "Libya"
						},
						{
							"code": "LIE",
							"name": "Liechtenstein"
						},
						{
							"code": "LTU",
							"name": "Litauen"
						},
						{
							"code": "LUX",
							"name": "Luxembourg"
						},
						{
							"code": "MAC",
							"name": "Macao"
						},
						{
							"code": "MDG",
							"name": "Madagaskar"
						},
						{
							"code": "MKD",
							"name": "Makedonia"
						},
						{
							"code": "MWI",
							"name": "Malawi"
						},
						{
							"code": "MYS",
							"name": "Malaysia"
						},
						{
							"code": "MDV",
							"name": "Maldivene"
						},
						{
							"code": "MLI",
							"name": "Mali"
						},
						{
							"code": "MLT",
							"name": "Malta"
						},
						{
							"code": "IMN",
							"name": "Man"
						},
						{
							"code": "MAR",
							"name": "Marokko"
						},
						{
							"code": "MHL",
							"name": "Marshalløyene"
						},
						{
							"code": "MTQ",
							"name": "Martinique"
						},
						{
							"code": "MRT",
							"name": "Mauritania"
						},
						{
							"code": "MUS",
							"name": "Mauritius"
						},
						{
							"code": "MYT",
							"name": "Mayotte"
						},
						{
							"code": "MEX",
							"name": "Mexico"
						},
						{
							"code": "FSM",
							"name": "Mikronesiaføderasjonen"
						},
						{
							"code": "MDA",
							"name": "Moldova"
						},
						{
							"code": "MCO",
							"name": "Monaco"
						},
						{
							"code": "MNG",
							"name": "Mongolia"
						},
						{
							"code": "MNE",
							"name": "Montenegro"
						},
						{
							"code": "MSR",
							"name": "Montserrat"
						},
						{
							"code": "MOZ",
							"name": "Mosambik"
						},
						{
							"code": "MMR",
							"name": "Myanmar"
						},
						{
							"code": "NAM",
							"name": "Namibia"
						},
						{
							"code": "NRU",
							"name": "Nauru"
						},
						{
							"code": "NLD",
							"name": "Nederland"
						},
						{
							"code": "NPL",
							"name": "Nepal"
						},
						{
							"code": "NIC",
							"name": "Nicaragua"
						},
						{
							"code": "NER",
							"name": "Niger"
						},
						{
							"code": "NGA",
							"name": "Nigeria"
						},
						{
							"code": "NIU",
							"name": "Niue"
						},
						{
							"code": "PRK",
							"name": "Nord-Korea"
						},
						{
							"code": "MNP",
							"name": "Nord-Marianene"
						},
						{
							"code": "NFK",
							"name": "Norfolkøya"
						},
						{
							"code": "NOR",
							"name": "Norge"
						},
						{
							"code": "NCL",
							"name": "Ny-Caledonia"
						},
						{
							"code": "NZL",
							"name": "Ny-Zealand"
						},
						{
							"code": "OMN",
							"name": "Oman"
						},
						{
							"code": "PAK",
							"name": "Pakistan"
						},
						{
							"code": "PLW",
							"name": "Palau"
						},
						{
							"code": "PAN",
							"name": "Panama"
						},
						{
							"code": "PNG",
							"name": "Papua Ny-Guinea"
						},
						{
							"code": "PRY",
							"name": "Paraguay"
						},
						{
							"code": "PER",
							"name": "Peru"
						},
						{
							"code": "PCN",
							"name": "Pitcairnøyene"
						},
						{
							"code": "POL",
							"name": "Polen"
						},
						{
							"code": "PRT",
							"name": "Portugal"
						},
						{
							"code": "PRI",
							"name": "Puerto Rico"
						},
						{
							"code": "QAT",
							"name": "Qatar"
						},
						{
							"code": "COG",
							"name": "Republikken Kongo"
						},
						{
							"code": "ROU",
							"name": "Romania"
						},
						{
							"code": "RUS",
							"name": "Russland"
						},
						{
							"code": "RWA",
							"name": "Rwanda"
						},
						{
							"code": "REU",
							"name": "Réunion"
						},
						{
							"code": "KNA",
							"name": "Saint Kitts og Nevis"
						},
						{
							"code": "LCA",
							"name": "Saint Lucia"
						},
						{
							"code": "VCT",
							"name": "Saint Vincent og Grenadinene"
						},
						{
							"code": "BLM",
							"name": "Saint-Barthélemy"
						},
						{
							"code": "MAF",
							"name": "Saint-Martin"
						},
						{
							"code": "SPM",
							"name": "Saint-Pierre og Miquelon"
						},
						{
							"code": "SLB",
							"name": "Salomonøyene"
						},
						{
							"code": "WSM",
							"name": "Samoa"
						},
						{
							"code": "SMR",
							"name": "San Marino"
						},
						{
							"code": "SAU",
							"name": "Saudi-Arabia"
						},
						{
							"code": "SEN",
							"name": "Senegal"
						},
						{
							"code": "SRB",
							"name": "Serbia"
						},
						{
							"code": "SYC",
							"name": "Seychellene"
						},
						{
							"code": "SLE",
							"name": "Sierra Leone"
						},
						{
							"code": "SGP",
							"name": "Singapore"
						},
						{
							"code": "SXM",
							"name": "Sint Maarten"
						},
						{
							"code": "SVK",
							"name": "Slovakia"
						},
						{
							"code": "SVN",
							"name": "Slovenia"
						},
						{
							"code": "SOM",
							"name": "Somalia"
						},
						{
							"code": "ESP",
							"name": "Spania"
						},
						{
							"code": "LKA",
							"name": "Sri Lanka"
						},
						{
							"code": "SHN",
							"name": "St. Helena, Ascension og Tristan da Cunha"
						},
						{
							"code": "GBR",
							"name": "Storbritannia"
						},
						{
							"code": "SDN",
							"name": "Sudan"
						},
						{
							"code": "SUR",
							"name": "Surinam"
						},
						{
							"code": "SJM",
							"name": "Svalbard og Jan Mayen"
						},
						{
							"code": "CHE",
							"name": "Sveits"
						},
						{
							"code": "SWE",
							"name": "Sverige"
						},
						{
							"code": "SWZ",
							"name": "Swaziland"
						},
						{
							"code": "SYR",
							"name": "Syria"
						},
						{
							"code": "STP",
							"name": "São Tomé og Príncipe"
						},
						{
							"code": "ZAF",
							"name": "Sør-Afrika"
						},
						{
							"code": "SGS",
							"name": "Sør-Georgia og Sør-Sandwichøyene"
						},
						{
							"code": "KOR",
							"name": "Sør-Korea"
						},
						{
							"code": "SSD",
							"name": "Sør-Sudan"
						},
						{
							"code": "TJK",
							"name": "Tadsjikistan"
						},
						{
							"code": "TWN",
							"name": "Taiwan"
						},
						{
							"code": "TZA",
							"name": "Tanzania"
						},
						{
							"code": "THA",
							"name": "Thailand"
						},
						{
							"code": "TGO",
							"name": "Togo"
						},
						{
							"code": "TKL",
							"name": "Tokelau"
						},
						{
							"code": "TON",
							"name": "Tonga"
						},
						{
							"code": "TTO",
							"name": "Trinidad og Tobago"
						},
						{
							"code": "TCD",
							"name": "Tsjad"
						},
						{
							"code": "CZE",
							"name": "Tsjekkia"
						},
						{
							"code": "TUN",
							"name": "Tunisia"
						},
						{
							"code": "TKM",
							"name": "Turkmenistan"
						},
						{
							"code": "TCA",
							"name": "Turks- og Caicosøyene"
						},
						{
							"code": "TUV",
							"name": "Tuvalu"
						},
						{
							"code": "TUR",
							"name": "Tyrkia"
						},
						{
							"code": "DEU",
							"name": "Tyskland"
						},
						{
							"code": "UGA",
							"name": "Uganda"
						},
						{
							"code": "UKR",
							"name": "Ukraina"
						},
						{
							"code": "HUN",
							"name": "Ungarn"
						},
						{
							"code": "URY",
							"name": "Uruguay"
						},
						{
							"code": "USA",
							"name": "USA"
						},
						{
							"code": "UMI",
							"name": "USAs ytre småøyer"
						},
						{
							"code": "UZB",
							"name": "Usbekistan"
						},
						{
							"code": "VUT",
							"name": "Vanuatu"
						},
						{
							"code": "VAT",
							"name": "Vatikanstaten"
						},
						{
							"code": "VEN",
							"name": "Venezuela"
						},
						{
							"code": "ESH",
							"name": "Vest-Sahara"
						},
						{
							"code": "VNM",
							"name": "Vietnam"
						},
						{
							"code": "WLF",
							"name": "Wallis- og Futunaøyene"
						},
						{
							"code": "ZMB",
							"name": "Zambia"
						},
						{
							"code": "ZWE",
							"name": "Zimbabwe"
						},
						{
							"code": "ALA",
							"name": "Åland"
						},
						{
							"code": "TLS",
							"name": "Øst-Timor"
						},
						{
							"code": "AUT",
							"name": "Østerrike"
						}
					];
				}
			]);
}());
